import { v4 as uuidv4 } from "uuid";
import { GET_CART } from "../database/get-stored-data";
import { extractEncryptedElementValue } from "./store_sessions";

var $ = require("jquery");

export const get_Href_URL_Params = function () {
  var params = {};
  var url = window.location.href;
  let index = url.indexOf("?");
  if (index !== -1) {
    let result = url.substring(index).replace("?", "");
    var vars = result.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split(/=(.*)/s);

      params[pair[0]] = pair[1];
    }
  }
  return params;
};

export const HEADER_TAB_SETUP = async ({
  HeaderTabName = String,
  FnGoBackScreen = Function,
  HeaderNavigatorMenuDisplay = Boolean,
  HeaderBackButtonDisplay = true,
  HeaderNavigatorMenuFaBoostrapIconName = "bi bi-search",
  FnHeaderNavigatorMenu = Function,
}) => {
  $("#HeaderTabName").html(HeaderTabName.toUpperCase());
  var btnZoneHomeScreen = document.getElementById("HeaderNavigatorBackButton");
  var HeaderNavigatorBoostrapIcon = document.getElementById("HeaderNavigatorBoostrapIcon");
  if (btnZoneHomeScreen) {
    btnZoneHomeScreen.style.display = HeaderBackButtonDisplay ? "block" : "none";
    $("#HeaderNavigatorBackButton").prop("onclick", null).off("click");
    $("#HeaderNavigatorBackButton").on("click", async function () {
      await FnGoBackScreen();
    });
  }
  if (HeaderNavigatorMenuDisplay) {
    document.getElementById("HeaderNavigatorMenu").style.display = "flex";
  } else {
    document.getElementById("HeaderNavigatorMenu").style.display = "none";
  }
  if (HeaderNavigatorBoostrapIcon) {
    document.getElementById('HeaderNavigatorBoostrapIcon').className = HeaderNavigatorMenuFaBoostrapIconName
  }
  $("#HeaderNavigatorMenu").prop("onclick", null).off("click");
  $("#HeaderNavigatorMenu").on("click", async function () {
    await FnHeaderNavigatorMenu();
  });
  // HeaderNavigatorMenu;
};

export const FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS = async ({
  FnFilterTextBox = Function,
  FnFilterCloseButton = Function,
  FnFilterClearButton = Function,
}) => {
  var btnproductlistFilterTextBoxClsoe = document.getElementById("btnproductlistFilterTextBoxClsoe");
  var btnproductlistFilterTextBoxclear = document.getElementById("btnproductlistFilterTextBoxclear");
  var InputproductlistFilterTextBox = document.getElementById("InputproductlistFilterTextBox");
  
  // Function to hide the shadow overlay
  const hideShadowOverlay = () => {
    let overlay = document.querySelector('.shadow-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  };

  if (btnproductlistFilterTextBoxclear) {
    $("#btnproductlistFilterTextBoxclear").prop("onclick", null).off("click");
    $("#btnproductlistFilterTextBoxclear").on("click", async function () {
      document.getElementById("InputproductlistFilterTextBox").value = "";
      FnFilterClearButton();
      hideShadowOverlay(); // Optionally hide the shadow when the clear button is clicked
    });
  }
  if (btnproductlistFilterTextBoxClsoe) {
    $("#btnproductlistFilterTextBoxClsoe").prop("onclick", null).off("click");
    $("#btnproductlistFilterTextBoxClsoe").on("click", async function () {
      document.getElementById("InputproductlistFilterTextBox").value = "";
      FnFilterCloseButton();
      // Shadow is already hidden in the FnFilterCloseButton implementation
    });
  }

  if (InputproductlistFilterTextBox) {
    $("#InputproductlistFilterTextBox").prop("oninput", null).off("input");
    $("#InputproductlistFilterTextBox").on("input", async function (event) {
      await FnFilterTextBox(event);
      hideShadowOverlay(); // Hide the shadow when a character is typed
    });
  }
};


export const CONCAT_TEXT_LIMIT = ({ length, string }) => {
  var trimmedString =
    string.length > length ? string.substring(0, length - 3) + "..." : string;
  return trimmedString;
};

export const KEY_GENERATOR = () => {
  return uuidv4();
};

export const DRAWER_HOME_SCREEN_ZONE_BUTTON_CLICK_EVENT = async (
  btnZoneHomeSc
) => {
  //ZoneHomeScreen
  var btnZoneHomeScreen = document.getElementById("ZoneHomeScreen");
  if (btnZoneHomeScreen) {
    $("#ZoneHomeScreen").prop("onclick", null).off("click");
    $("#ZoneHomeScreen").on("click", async function () {
      await btnZoneHomeSc();
    });
  }
};

export const DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT = async (
  btnDrawerCloseSc,
  id = "DrawerClose"
) => {
  var btnDrawerClose = document.getElementById(id);
  if (btnDrawerClose) {
    $("#" + id)
      .prop("onclick", null)
      .off("click");
    $("#" + id).on("click", async function () {
      await btnDrawerCloseSc();
    });
  }
};

export const FORMAT_DECIMAL_VALUE = (TYPE, AMOUNT, DECIMALPOINT) => {
  let value;
  if (AMOUNT === "") {
    value = parseFloat(0.0)
      .toFixed(parseInt(DECIMALPOINT))
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return value;
  }
  let AMT = AMOUNT.toString().replace(/,/g, "");
  if (TYPE === 1) {
    value = parseFloat(AMT)
      .toFixed(parseInt(DECIMALPOINT))
      .replace(/\B(===()+(===!==\d))/g, ",");
    return parseFloat(value);
  } else if (TYPE === 2) {
    value = parseFloat(AMOUNT)
      .toFixed(parseInt(DECIMALPOINT))
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const GET_CART_COUNT = async (cartItems) => {
  let lbl = document.getElementById("lblCartCount");
  if (lbl) {
    let cart = cartItems;
    if (!Array.isArray(cart)) {
      cart = await GET_CART();
    }
    if (cart === undefined) {
      $("#lblCartCount").html(0);
    } else {
      $("#lblCartCount").html(cart.length);
    }
  }
};

export const HORIZONTAL_SECTION_DRAGBLE_MOUSE = (className) => {
  const container = document.querySelector(className);

  let startY;
  let startX;
  let scrollLeft;
  let scrollTop;
  let isDown;

  container.addEventListener("mousedown", (e) => mouseIsDown(e));
  container.addEventListener("mouseup", (e) => mouseUp(e));
  container.addEventListener("mouseleave", (e) => mouseLeave(e));
  container.addEventListener("mousemove", (e) => mouseMove(e));

  function mouseIsDown(e) {
    isDown = true;
    startY = e.pageY - container.offsetTop;
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
    scrollTop = container.scrollTop;
  }
  function mouseUp(e) {
    isDown = false;
  }
  function mouseLeave(e) {
    isDown = false;
  }
  function mouseMove(e) {
    if (isDown) {
      e.preventDefault();
      //Move vertcally
      const y = e.pageY - container.offsetTop;
      const walkY = y - startY;
      container.scrollTop = scrollTop - walkY;

      //Move Horizontally
      const x = e.pageX - container.offsetLeft;
      const walkX = x - startX;
      container.scrollLeft = scrollLeft - walkX;
    }
  }
};

export const COPY_ELEMENT_TEXT = ({ classname }) => {
  const element = document.getElementsByClassName(classname)[0];
  var text = extractEncryptedElementValue(element);
  if (text !== undefined) {
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    elem.value = text.trim();
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);
    return true;
  } else {
    return false;
  }
};
export const DIFERENCE_MINUTES = (dt2, dt1) => {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
};

export const CONVERT_TIME_12TO24 = (time12h) => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};

export const GET_CART_PIDs = async () => {
  let cart = await GET_CART();
  let PIDs = "";
  if (cart.length > 0) {
    for (let c = 0; c < cart.length; c++) {
      PIDs += "," + cart[c].PID;
    }
    if (PIDs.length > 1) {
      PIDs = PIDs.substring(1);
    }
  }
  return PIDs;
};

export const GENERATE_NIC = () => {
  var yourDate = new Date(); // for example

  // the number of .net ticks at the unix epoch
  var epochTicks = 621355968000000000;

  // there are 10000 .net ticks per millisecond
  var ticksPerMillisecond = 10000;

  // calculate the total number of .net ticks for your date
  var yourTicks = epochTicks + yourDate.getTime() * ticksPerMillisecond;

  var NIC = "NIC";
  var results = "{ " + '"' + NIC + '"' + ": " + '"' + yourTicks.toString() + '"' + " }";
  return results;
};
